import { render } from "./portal_request.html?vue&type=template&id=48f52e16&external"
import script from "./portal_request.js?vue&type=script&lang=js&external"
export * from "./portal_request.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__